import React, { useState, useEffect } from 'react';
import { getApiBaseUrl, setApiBaseUrl, resetApiBaseUrl } from '../config/config';
import ApiStatus from '../components/common/ApiStatus';

const Settings = () => {
  const [apiUrl, setApiUrl] = useState('');
  const [message, setMessage] = useState({ text: '', type: '' });


  useEffect(() => {
    setApiUrl(getApiBaseUrl());
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (setApiBaseUrl(apiUrl)) {
      setMessage({
        text: 'تم حفظ عنوان API بنجاح. يرجى إعادة تحميل الصفحة لتطبيق التغييرات.',
        type: 'success'
      });


      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } else {
      setMessage({
        text: 'يرجى إدخال عنوان API صالح',
        type: 'error'
      });
    }
  };

  const handleReset = () => {
    resetApiBaseUrl();
    setApiUrl(getApiBaseUrl());
    setMessage({
      text: 'تم إعادة تعيين عنوان API إلى الإعداد الافتراضي. يرجى إعادة تحميل الصفحة لتطبيق التغييرات.',
      type: 'success'
    });


    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };

  return (
    <div className="container py-5">
      <h2 className="text-center mb-4">إعدادات التطبيق</h2>

      <div className="settings-section">
        <div className="settings-card">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h3 className="mb-0">إعدادات الاتصال بالخادم</h3>
            <ApiStatus />
          </div>

          {message.text && (
            <div className={`alert alert-${message.type === 'success' ? 'success' : 'danger'}`} role="alert">
              {message.text}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="apiUrl" className="form-label">
                عنوان API الأساسي
              </label>
              <input
                type="text"
                className="form-control"
                id="apiUrl"
                name="apiUrl"
                value={apiUrl}
                onChange={(e) => setApiUrl(e.target.value)}
                placeholder="مثال: http://localhost:5000"
                required
              />
              <small className="form-text text-muted">
                أدخل عنوان URL الكامل للـ API بدون شرطة مائلة في النهاية
              </small>
            </div>

            <div className="d-flex gap-2 mt-3">
              <button
                type="submit"
                className="btn btn-primary"
              >
                حفظ الإعدادات
              </button>

              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={handleReset}
              >
                إعادة تعيين
              </button>
            </div>
          </form>
        </div>


      </div >
    </div >
  );
};

export default Settings;
